import getBaseDisplayLabel from './getBaseDisplayLabel';
import context from '../context';
import { formatShortTime } from '../utils';
import gettext from '../lang/gettext';

export default function getShiftDisplayLabels(shift) {
  return {
    label: getLabel(shift),
    labelHiddenEndTime: getLabel(shift, true),
    breakLabel: getBreakLabel(shift),
    tagLabel: getTagLabel(shift),
  };
}

function getLabel(shift, forceHiddenEndTime) {
  let label = '';
  const canSeeEndTime = context.me.isManager && !forceHiddenEndTime;
  if (shift.openEnd) {
    if (!canSeeEndTime || shift.dtstart.getTime() === shift.dtend.getTime()) {
      label = gettext('Starts at %(time)s', {
        time: formatShortTime(shift.dtstart, context.usTimeFormat),
      });
    } else {
      label = getBaseDisplayLabel(shift.dtstart, shift.dtend, context.usTimeFormat);
    }
  } else if (shift.fullDay) {
    label = gettext('All day');
  } else {
    label = getBaseDisplayLabel(shift.dtstart, shift.dtend, context.usTimeFormat);
  }
  return label;
}

function getBreakLabel(shift) {
  let breakLabel = '';

  if (
    shift.breakDuration &&
    context.laborCostSettings &&
    context.laborCostSettings.shiftBreakType
  ) {
    breakLabel = gettext('%(duration)s min break', { duration: shift.breakDuration });
  }

  return breakLabel;
}

function getTagLabel(shift) {
  let label = '';

  if (shift.tags && shift.tags.length) {
    label = shift.tags.map((t) => t.name).join(' • ');
  }

  // display empty unbreakable space in case when shift does not have tags added
  return label || '\xa0';
}
